import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';

import { CheckPersonRulesMatrixModel, GetPersonModel, PersonModel } from '@bayclubs/court-booking-employee-api';
import { BcStateContext, BcStateListContext } from '@bayclubs/state';

import { PlayersSelectors } from './players.selectors';
import * as actions from './players.actions';
import { ChangePlayerInputModel } from '../models/change-player-input.model';

@Injectable({ providedIn: 'root' })
export class PlayersFacade {
    @Select(PlayersSelectors.getPlayer) player$: Observable<BcStateContext<GetPersonModel>>;
    @Select(PlayersSelectors.getPlayers) players$: Observable<BcStateListContext<PersonModel>>;
    @Select(PlayersSelectors.getSelectedPlayer) selectedPlayer$: Observable<PersonModel>;
    @Select(PlayersSelectors.getSelectedPlayerRulesMatrix) selectedPlayerRulesMatrix$: Observable<CheckPersonRulesMatrixModel>;

    constructor(private store: Store) {}

    loadPlayer = (playerInput: ChangePlayerInputModel) => this.store.dispatch(new actions.LoadPlayerAction(playerInput));
    searchPlayers = (search: string) => this.store.dispatch(new actions.SearchPlayersAction(search));
    selectPlayer = (player: PersonModel) => this.store.dispatch(new actions.SelectPlayerAction(player));
    changePlayer = (courtBookingId: string) => this.store.dispatch(new actions.ChangePlayerAction(courtBookingId));
    clearPlayersFormData = () => this.store.dispatch(new actions.ClearPlayersFormDataAction());
    addPlayer = (email: string, phone: string) => this.store.dispatch(new actions.AddPlayerAction(email, phone));
    clearPlayers = () => this.store.dispatch(new actions.ClearPlayersAction());
    checkPlayerRulesMatrix = () => this.store.dispatch(new actions.CheckPlayerRulesMatrixAction());
}
